import EF from 'ef/ef';
import { KeybindingService, keys } from 'services/keybinding-service';
import LocaleService from 'services/locale-service';
import VideoServiceBase from 'services/video-service-base';
import IconLoadService from 'services/icon-load-service';
import EnrollmentDataService from 'services/enrollment-data-service';

const { ArrowLeft, ArrowRight } = keys;

export default class VideoServiceDash extends VideoServiceBase {
  constructor(view) {
    super(view);
    const iconTranscript = {
      icon_prefix: 'far',
      icon_name: 'fa-comment-alt-lines',
      caption: LocaleService.t('btn-transcript'),
      class: 'icon-transcript',
    };
    IconLoadService.applyIcon(iconTranscript.icon_name, view.cid, iconTranscript.class, iconTranscript.icon_prefix);
    var dashControlbar = require('views/block/video/templates/dash-controlbar');
    var videoEl = view.el.querySelector(`.accessibility-wrapper video`);
    videoEl.insertAdjacentHTML(
      'afterend',
      dashControlbar({
        transcript: view.model.get('transcript'),
        cid: view.cid,
        iconTranscript,
      })
    );
    if (view.model.has('height') && view.el && videoEl) {
      let barHeight = view.el.querySelector('#videoController').offsetHeight;
      videoEl.height = view.model.get('height') - barHeight;
    }
    if (view.model.has('width') && videoEl) {
      videoEl.width = view.model.get('width');
    }

    document.addEventListener('fullscreenchange', this.onFullScreenChanged.bind(this), false);
    document.addEventListener('MSFullscreenChange', this.onFullScreenChanged.bind(this), false);
    document.addEventListener('mozfullscreenchange', this.onFullScreenChanged.bind(this), false);
    document.addEventListener('webkitfullscreenchange', this.onFullScreenChanged.bind(this), false);

    Chaplin.mediator.subscribe('media:captions:change', this.toggleCaptions.bind(this));

    this.addOutlineOnFocus();
  }

  // prevent hidden elements from getting a11y focus while on fullscreen mode.
  onFullScreenChanged() {
    var fullscreenElement =
      document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement;
    if (fullscreenElement) {
      this.video.controls = true;
      this.savedCaptions = EnrollmentDataService.getData('closed_captions');
      this.video.addEventListener('volumechange', () => {
        this.lastVolume = this.video.volume;
        if (this.video.muted) {
          this.controlbar.setVolume(0);
        } else {
          this.controlbar.setVolume(this.lastVolume || 1);
        }
      });
    }
    let nextSibling = $('#videoController');
    if (nextSibling.length) {
      var buttons = nextSibling.find('button');
      Array.from(buttons).forEach(button => {
        button.setAttribute('tabindex', fullscreenElement ? -1 : 0);
      });
    }
    this.video.textTracks.onchange = event => {
      EnrollmentDataService.saveData(
        'closed_captions',
        event.target[0].mode === 'showing' ? LocaleService.t('currentLanguage').toUpperCase() : 'OFF'
      );
    };
    if (!fullscreenElement) {
      this.video.controls = false;
      const captionsNow = EnrollmentDataService.getData('closed_captions');
      if (this.savedCaptions !== captionsNow) {
        let elements = nextSibling.find('#captionMenu li');
        if (elements.length > 0) {
          Array.from(elements).forEach(item => {
            item.classList.toggle('menu-item-selected', item.innerText.toUpperCase() === captionsNow);
            item.classList.toggle('menu-item-unselected', !item.innerText.toUpperCase() === captionsNow);
          });
        }
        Chaplin.mediator.publish('media:captions:change');
      }
      this.video.removeEventListener('volumechange', event);
    }
  }

  buildVideoPlayer(metadata, options) {
    const info = super.buildVideoPlayer(metadata, options);
    const savedCaption = EnrollmentDataService.getData('closed_captions');

    this.player = dashjs.MediaPlayer().create();
    this.player.getDebug().setLogToBrowserConsole(false);

    this.player.initialize();
    const bitrateIndex = EnrollmentDataService.getData('bitrateIndex');
    if (bitrateIndex !== undefined) {
      this.player.setAutoSwitchQualityFor('video', false);
    }

    // autoplay is false since the view handles that behavior
    this.player.setAutoPlay(false);
    this.player.attachView(this.video);
    this.player.attachSource(info.manifestUrl);
    if (bitrateIndex !== undefined) {
      this.player.on(dashjs.MediaPlayer.events.STREAM_INITIALIZED, () => {
        if (bitrateIndex >= 0) {
          this.player.on(dashjs.MediaPlayer.events.CAN_PLAY, () => {
            this.player.setQualityFor('video', bitrateIndex);
            $('#bitrateMenu .menu-item-selected').addClass('menu-item-unselected').removeClass('menu-item-selected');
            $(`#video-bitrate-listItem_${bitrateIndex + 1}`)
              .addClass('menu-item-selected')
              .removeClass('menu-item-unselected');
          });
        }
      });
    }

    // Cross browser support for the native control bar is poor
    // The native controls for Firefox did not display the closed captioning button
    // As such dash.js provides this js/html/css controlbar
    this.controlbar = new ControlBar(this.player);
    this.controlbar.initialize();

    // By default captions are displayed on first load.
    // There is no setting in dash.js to default to not showing captions
    // This will set dash.js to not display captions and have the ControlBar styles match
    this.player.on(dashjs.MediaPlayer.events.TEXT_TRACKS_ADDED, () => {
      if (!savedCaption) {
        setTimeout(() => this.player.setTextTrack(-1), 0);
      }

      let nextSibling = this.video.nextSibling;
      if (nextSibling !== null) {
        let elements = nextSibling.querySelectorAll('#captionMenu li');
        if (elements.length > 0) {
          Array.from(elements).forEach(item => {
            item.classList.remove('menu-item-selected');
            item.classList.add('menu-item-unselected');

            if (item.innerText === 'OFF') {
              item.innerText = LocaleService.t('off');
            } else if (item.innerText.includes(LocaleService.lang)) {
              item.innerText = LocaleService.t('currentLanguage');
            }

            applySavedCaption(item);
          });
        }
      }
    });

    // set text track to saved caption
    const applySavedCaption = item => {
      const itemCaption = item.innerText.toUpperCase();
      if (savedCaption && itemCaption === savedCaption) {
        if (item.classList.contains('menu-item-unselected')) {
          this.player.on(dashjs.MediaPlayer.events.CAN_PLAY, () => {
            this.player.setTextTrack(item.index - 1);
          });
          item.classList.remove('menu-item-unselected');
          item.classList.add('menu-item-selected');
        }
      }
    };

    // Accessibility concerns for the control bar
    // * The menu must be next to the button which opens them,
    //   so the tab order is correct
    // * Each menu item must have a button with tabindex set to 0
    //   so that it can be tabbed into
    // * Button elements forward the enter key to a click event
    //   so they work with a keyboard while spans/divs do not
    this.player.on(dashjs.MediaPlayer.events.CAN_PLAY, () => {
      this.moveElement('#captionMenu').toAfter('#captionBtn');
      this.wrapMenuItemsWithButton('#captionMenu');

      this.moveElement('#bitrateMenu').toAfter('#bitrateListBtn');
      this.wrapMenuItemsWithButton('#bitrateMenu');
      this.player.on(dashjs.MediaPlayer.events.QUALITY_CHANGE_REQUESTED, e => {
        //first item is the auto quality option, check if it's selected
        const autoQualityEnabled = $('#bitrateMenu li:first-child').hasClass('menu-item-selected');
        const newQuality = autoQualityEnabled ? null : e.newQuality;
        EnrollmentDataService.saveData('bitrateIndex', newQuality);
      });

      const volume = this.loadVolume();
      if (volume) {
        this.player.setVolume(volume);
        $('#volumebar').val(volume);
      }
    });

    this.addAria('#playPauseBtn, #playPauseBtn button', 'videoAccessibility.play');
    this.addAria('#videoTime', 'videoAccessibility.time');
    this.addAria('.seekContainer, #seekbar', 'videoAccessibility.seeker');
    this.addAria('#videoDuration', 'videoAccessibility.duration');
    this.addAria('#captionBtn, #captionBtn button', 'videoAccessibility.captions');
    this.addAria('#muteBtn, #muteBtn button', 'videoAccessibility.mute');
    this.addAria('#volumebar', 'videoAccessibility.volumebar');
    this.addAria('#trackSwitchBtn', 'videoAccessibility.tracks');
    this.addAria('#bitrateListBtn, #bitrateListBtn button', 'videoAccessibility.bitrate');
    this.addAria('#fullscreenBtn, #fullscreenBtn button', 'videoAccessibility.fullscreen');
    this.addAria('#transcriptBtn, #transcriptBtn button', 'videoAccessibility.transcript');

    this.initializeMuteState();

    //save closed caption
    $('#videoController').click(function (e) {
      const target = $(e.target)[0];
      if (
        (target.id && target.id.includes('caption-listItem')) ||
        target.parentElement.id.includes('caption-listItem')
      ) {
        EnrollmentDataService.saveData('closed_captions', target.innerText.toUpperCase());
      }
    });

    return true;
  }

  addAria(selector, key, attribute, value) {
    const translation = value ? value : LocaleService.t(key);
    attribute = attribute || 'aria-label';
    if (translation !== '' && translation !== key) {
      let nextSibling = this.video.nextSibling;
      if (nextSibling !== null) {
        let elements = nextSibling.querySelectorAll(selector);
        if (elements.length > 0) {
          Array.from(elements).forEach(element => {
            element.setAttribute(attribute, translation);
          });
        }
      }
    }
  }

  wrapMenuItemsWithButton(selector) {
    let nextSibling = this.video.nextSibling;
    if (nextSibling !== null) {
      let elements = nextSibling.querySelectorAll(`${selector} li`);
      if (elements.length > 0) {
        Array.from(elements).forEach(item => {
          var button = document.createElement('button');
          button.setAttribute('tabindex', 0);
          button.innerText =
            item.innerText.trim() === 'Auto Switch'
              ? `${LocaleService.t('videoAccessibility.autoSwitch')}`
              : item.innerText;
          button.setAttribute('aria-label', item.innerText);
          item.innerText = '';
          item.appendChild(button);
        });
      }
    }
  }

  moveElement(sourceSelector) {
    var nextSibling = this.video.nextSibling;
    if (nextSibling !== null) {
      var sourceElement = this.video.nextSibling.querySelector(sourceSelector);
    }
    return {
      toAfter: targetSelector => {
        if (sourceElement && this.video.nextSibling) {
          this.video.nextSibling.insertBefore(
            sourceElement,
            this.video.nextSibling.querySelector(targetSelector).nextSibling
          );
        }
      },
    };
  }

  setupEvents(callbacks) {
    super.setupEvents();
    this.player.on(dashjs.MediaPlayer.events.CAN_PLAY, this.onReady.bind(this));
    this.player.on(dashjs.MediaPlayer.events.PLAYBACK_STARTED, callbacks.play);
    this.player.on(dashjs.MediaPlayer.events.PLAYBACK_STARTED, this.play.bind(this));
    this.player.on(dashjs.MediaPlayer.events.PLAYBACK_PAUSED, callbacks.pause);
    this.player.on(dashjs.MediaPlayer.events.PLAYBACK_PAUSED, this.pause.bind(this));
    this.player.on(dashjs.MediaPlayer.events.PLAYBACK_TIME_UPDATED, this.onTime.bind(this));
    this.player.on(dashjs.MediaPlayer.events.PLAYBACK_ENDED, callbacks.end);
    this.player.on(dashjs.MediaPlayer.events.PLAYBACK_SEEKING, this.onSeek.bind(this));
    this.player.on(dashjs.MediaPlayer.events.ERROR, this.error.bind(this));
    $(this.video.nextSibling).find('#volumebar').on('change', this.onVolume.bind(this));
    $(this.video.nextSibling).find('#seekbar').on('keydown', this.onKeyDownSeek.bind(this));
    $(this.video.nextSibling).find('#seekbar').on('mousedown', this.onSeeking.bind(this));
    $(this.video.nextSibling).find('#muteBtn button').on('click', this.onMuteClick.bind(this));
    $(this.video.nextSibling).find('#captionBtn button').on('click', this.onButtonPress.bind(this));
    $(this.video.nextSibling).find('#bitrateListBtn button').on('click', this.onButtonPress.bind(this));
    $(this.video.nextSibling).find('#fullscreenBtn button').on('click', this.onButtonPress.bind(this));

    this.destroyEvents = () => {
      this.player.off(dashjs.MediaPlayer.events.CAN_PLAY, this.onReady);
      this.player.off(dashjs.MediaPlayer.events.PLAYBACK_STARTED, callbacks.play);
      this.player.off(dashjs.MediaPlayer.events.PLAYBACK_STARTED, this.play);
      this.player.off(dashjs.MediaPlayer.events.PLAYBACK_PAUSED, callbacks.pause);
      this.player.off(dashjs.MediaPlayer.events.PLAYBACK_PAUSED, this.pause);
      this.player.off(dashjs.MediaPlayer.events.PLAYBACK_TIME_UPDATED, this.onTime);
      this.player.off(dashjs.MediaPlayer.events.PLAYBACK_ENDED, callbacks.end);
      this.player.off(dashjs.MediaPlayer.events.PLAYBACK_SEEKING, this.onSeek);
      this.player.off(dashjs.MediaPlayer.events.ERROR, this.error);
      $(this.video.nextSibling).find('#volumebar').off('change', this.onVolume);
      $(this.video.nextSibling).find('#seekbar').off('keydown', this.onKeyDownSeek);
      $(this.video.nextSibling).find('#seekbar').off('mousedown', this.onSeeking);
      $(this.video.nextSibling).find('#muteBtn button').off('click', this.onMuteClick);
      $(this.video.nextSibling).find('#captionBtn button').off('click', this.onButtonPress.bind(this));
      $(this.video.nextSibling).find('#bitrateListBtn button').off('click', this.onButtonPress.bind(this));
      $(this.video.nextSibling).find('#fullscreenBtn button').off('click', this.onButtonPress.bind(this));
    };
  }

  error(e) {
    console.error('Error playing video:', e); //eslint-disable-line no-console
  }

  toggleCaptions() {
    // Cycle through the captions
    const currentTrackIndex = this.player.getCurrentTextTrackIndex();
    const textTracksLength = this.video.textTracks.length;
    if (currentTrackIndex + 1 >= textTracksLength) {
      this.player.setTextTrack(-1);
    } else {
      this.player.setTextTrack(currentTrackIndex + 1);
    }
  }

  onReady() {
    this.trigger('ready');
    this.addAria('#videoDuration', '', 'aria-label', this.durationTimeLabel());
    if (this.getMute()) {
      this.addAria('#muteBtn, #muteBtn button', 'videoAccessibility.unmute');
    } else {
      this.addAria('#muteBtn, #muteBtn button', 'videoAccessibility.mute');
    }
  }

  onSeek(e) {
    if (!EF.options.local && this.progress) {
      if (e.seekTime > this.progress) {
        this.seek(this.currentTime);
      }
    }
  }

  onTime(e) {
    var seekbar = document.getElementById('seekbar');
    if (seekbar !== null) {
      seekbar.value = e.time;
      if (e.time > this.progress) {
        this.progress = e.time;
      }
      this.currentTime = e.time;
    }
    this.addAria('#seekbar', '', 'aria-valuetext', this.timeLabel());
    this.addAria('#videoTime', '', 'aria-label', this.currentTimeLabel());
  }

  timeLabel() {
    return LocaleService.t('videoAccessibility.timeLabel', {
      currentTime: this.toMinutesSeconds(this.currentTime),
      duration: this.toMinutesSeconds(this.getDuration()),
    });
  }

  currentTimeLabel() {
    return LocaleService.t('videoAccessibility.currentTimeLabel', {
      currentTime: this.toMinutesSeconds(this.currentTime),
    });
  }

  durationTimeLabel() {
    return LocaleService.t('videoAccessibility.durationTimeLabel', {
      duration: this.toMinutesSeconds(this.getDuration()),
    });
  }

  toMinutesSeconds(inputSeconds) {
    const secs = parseInt(inputSeconds, 10);
    let minutes = Math.floor(secs / 60);
    let seconds = secs - minutes * 60;
    if (minutes > 0) {
      return `${minutes} ${LocaleService.t('videoAccessibility.minutes')} ${seconds} ${LocaleService.t(
        'videoAccessibility.seconds'
      )}`;
    }
    return `${seconds} ${LocaleService.t('videoAccessibility.seconds')}`;
  }

  stop() {
    this.addAria('#playPauseBtn button', 'videoAccessibility.play');
    if (this.player) {
      this.player.pause();
      this.player.seek(0);
    }
  }

  play() {
    this.addAria('#playPauseBtn button', 'videoAccessibility.pause');
    if (this.player) {
      this.player.play();
      setTimeout(() => {
        if (!this.currentTime || this.currentTime > this.progress) {
          this.seek(this.progress);
        }
        if (this.player && this.player.isPaused()) {
          let startContainer = this.video.previousElementSibling;
          if (startContainer && startContainer.classList.contains('video-start-container')) {
            let label = startContainer.querySelector('label[for="startButton"]');
            if (label !== null) {
              label.innerText = LocaleService.t('videoAccessibility.start');
            }
            startContainer.classList.remove('hidden');
            startContainer.style.top = (this.video.offsetHeight - startContainer.clientHeight) / 2 + 'px';
            startContainer.style.left = (this.video.offsetWidth - startContainer.clientWidth) / 2 + 'px';
            startContainer.addEventListener(
              'click',
              () => {
                let container = this.video.previousElementSibling;
                if (container && container.classList.contains('video-start-container')) {
                  container.classList.add('hidden');
                }
                this.player.play();
              },
              true
            );
          }
        }
      }, 0);
    }
  }

  pause() {
    this.addAria('#playPauseBtn button', 'videoAccessibility.play');
    if (this.player) {
      this.player.pause();
    }
  }

  onMuteClick() {
    setTimeout(() => {
      const muteState = this.getMute();
      this.saveMuteState(muteState);
      if (muteState) {
        this.addAria('#muteBtn, #muteBtn button', 'videoAccessibility.mute');
      } else {
        this.addAria('#muteBtn, #muteBtn button', 'videoAccessibility.unmute');
      }
    });
  }

  mute() {
    this.addAria('#muteBtn button', 'videoAccessibility.unmute');
    if (this.player) {
      this.lastVolume = this.player.getVolume();
      this.controlbar.setVolume(this.loadVolume() || 1);
      this.controlbar.setVolume(0);
      this.saveMuteState(true);
    }
  }

  unmute() {
    this.addAria('#muteBtn button', 'videoAccessibility.mute');
    if (this.player) {
      this.player.setMute(false);
      this.controlbar.setVolume(this.lastVolume || 1);
      this.saveMuteState(false);
    }
  }

  onButtonPress(e) {
    const isPressed = $(e.currentTarget).attr('aria-pressed') === 'true';
    $(e.currentTarget).attr('aria-pressed', !isPressed);
  }

  getState() {
    if (!this.player) {
      return 'STOPPED';
    } else if (this.player.isPaused()) {
      return 'PAUSED';
    } else {
      return 'PLAYING';
    }
  }

  getPosition() {
    return this.player ? this.player.time() : 0;
  }

  getDuration() {
    return this.player ? this.player.duration() : 0;
  }

  seek(position) {
    if (position < 0 || position > this.getDuration()) return;
    if (this.player) {
      this.player.seek(position);
    }
  }

  getMute() {
    return this.player ? this.player.isMuted() : false;
  }

  setMute(mute) {
    if (mute) {
      this.lastVolume = this.player.getVolume();
      this.controlbar.setVolume(0);
    } else {
      this.controlbar.setVolume(this.lastVolume || 1);
    }
    this.player.setMute(mute);
  }

  increaseVolume(amount) {
    const currVolume = this.player.getVolume();
    if (this.controlbar && amount >= 0 && amount <= 1) {
      this.controlbar.setVolume(parseFloat(currVolume) + parseInt(amount) / 10);
    }
  }

  decreaseVolume(amount) {
    const currVolume = this.player.getVolume();
    if (this.controlbar && amount >= 0 && amount <= 1) {
      this.controlbar.setVolume(parseFloat(currVolume) - parseInt(amount) / 10);
    }
  }

  onVolume() {
    let $volumebar = $(this.video.nextSibling).find('#volumebar');
    this.saveVolume($volumebar.val());
    this.saveMuteState(false);
    this.addAria('#volumebar', '', 'aria-valuetext', $volumebar.val() * 100 + '%');
  }

  onKeyDownSeek(e) {
    KeybindingService.with(e).bind(
      ArrowLeft,
      () => {
        this.seek(this.getPosition() - 10);
      },
      ArrowRight,
      () => {
        this.seek(this.getPosition() + 10);
      }
    );
  }

  calculateTimeByEvent(event) {
    var seekbar = document.getElementById('seekbar');
    const seekbarRect = seekbar.getBoundingClientRect();
    return Math.floor((this.player.duration() * (event.clientX - seekbarRect.left)) / seekbarRect.width);
  }

  onSeeking(event) {
    const mouseTime = this.calculateTimeByEvent(event);
    if (!EF.options.local || mouseTime < this.progress) {
      this.seek(this.currentTime);
      const onSeeked = function (event) {
        document.removeEventListener('mouseup', onSeeked, true);

        // seeking
        let mouseTime = this.calculateTimeByEvent(event);
        if (!isNaN(mouseTime) && !this.isSeekBeyondBuffer(mouseTime)) {
          mouseTime = mouseTime < 0 ? 0 : mouseTime;
          this.player.seek(mouseTime);
        }
      }.bind(this);
      document.addEventListener('mouseup', onSeeked, true);
    }
  }

  getBufferLevel() {
    const dashMetrics = this.player.getDashMetrics();
    let bufferLevel = 0;
    if (dashMetrics) {
      bufferLevel = dashMetrics.getCurrentBufferLevel('video', true);
      if (!bufferLevel) {
        bufferLevel = dashMetrics.getCurrentBufferLevel('audio', true);
      }
    }
    return bufferLevel;
  }
  isSeekBeyondBuffer(seekPosition) {
    /**
     * bufferLevel indicates the playout duration for which
     * media data of the video is available starting from the
     * current playout time.
     */
    const bufferLevel = Number(this.getBufferLevel());
    const currentPosition = Number(this.getPosition());
    const allowableSeek = currentPosition + bufferLevel;

    if (isNaN(seekPosition) || isNaN(bufferLevel) || isNaN(allowableSeek)) {
      return false;
    }

    return seekPosition > allowableSeek;
  }
  dispose() {
    if (this.destroyEvents) {
      this.destroyEvents();
    }
    super.dispose();
    // This does not work currently
    // There's a pending PR to fix this https://github.com/Dash-Industry-Forum/dash.js/pull/2107
    //this.controlbar.destroy();
  }

  //adds outline on seekbar focus, fix for ie11
  addOutlineOnFocus() {
    $(this.video.nextSibling)
      .find('#seekbar')
      .on('focus', e => {
        $(e.target).parent('.seekContainer').addClass('outline');
      });
    $(this.video.nextSibling)
      .find('#seekbar')
      .on('blur', e => {
        $(e.target).parent('.seekContainer').removeClass('outline');
      });
  }
}
